import { render, staticRenderFns } from "./inspecao.vue?vue&type=template&id=dbec86be&scoped=true&"
import script from "./inspecao.vue?vue&type=script&lang=js&"
export * from "./inspecao.vue?vue&type=script&lang=js&"
import style0 from "./inspecao.vue?vue&type=style&index=0&id=dbec86be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec86be",
  null
  
)

export default component.exports